import axios from "axios";
import { BaseApiUrl } from "./base";
import { getCampusList } from './modules/misc';
import { normalizeDeptId, treeNodeDeptId } from '../utils/deptCascaderProps';

const base = BaseApiUrl;

// ========== 分组 ==========

export const getTeacherPatrolGroupListPage = (params) => {
  return axios.get(`${base}/api/TeacherPatrolGroup/GetList`, { params });
};

export const getTeacherPatrolGroupOptions = (params) => {
  return axios.get(`${base}/api/TeacherPatrolGroup/GetOptions`, { params });
};

export const getTeacherPatrolGroup = (id) => {
  return axios.get(`${base}/api/TeacherPatrolGroup/Get`, { params: { id } });
};

export const addTeacherPatrolGroup = (data) => {
  return axios.post(`${base}/api/TeacherPatrolGroup/Add`, data);
};

export const editTeacherPatrolGroup = (data) => {
  return axios.put(`${base}/api/TeacherPatrolGroup/Edit`, data);
};

export const deleteTeacherPatrolGroup = (id) => {
  return axios.delete(`${base}/api/TeacherPatrolGroup/Delete`, { params: { id } });
};

export const getTeacherPatrolGroupTerminals = (groupId) => {
  return axios.get(`${base}/api/TeacherPatrolGroup/GetTerminals`, { params: { groupId } });
};

export const saveTeacherPatrolGroupTerminals = (data) => {
  return axios.post(`${base}/api/TeacherPatrolGroup/SaveTerminals`, data);
};

export const getTeacherPatrolGroupStaff = (groupId) => {
  return axios.get(`${base}/api/TeacherPatrolGroup/GetStaff`, { params: { groupId } });
};

export const saveTeacherPatrolGroupStaff = (data) => {
  return axios.post(`${base}/api/TeacherPatrolGroup/SaveStaff`, data);
};

export const getTeacherPatrolTerminalOptions = (params) => {
  return axios.get(`${base}/api/TeacherPatrolGroup/GetTerminalOptions`, { params });
};

// ========== 时间段 ==========

export const getTeacherPatrolTimeSlotListPage = (params) => {
  return axios.get(`${base}/api/TeacherPatrolTimeSlot/GetList`, { params });
};

export const getTeacherPatrolTimeSlotOptions = (params) => {
  return axios.get(`${base}/api/TeacherPatrolTimeSlot/GetOptions`, { params });
};

export const getTeacherPatrolTimeSlot = (id) => {
  return axios.get(`${base}/api/TeacherPatrolTimeSlot/Get`, { params: { id } });
};

export const addTeacherPatrolTimeSlot = (data) => {
  return axios.post(`${base}/api/TeacherPatrolTimeSlot/Add`, data);
};

export const editTeacherPatrolTimeSlot = (data) => {
  return axios.put(`${base}/api/TeacherPatrolTimeSlot/Edit`, data);
};

export const deleteTeacherPatrolTimeSlot = (id) => {
  return axios.delete(`${base}/api/TeacherPatrolTimeSlot/Delete`, { params: { id } });
};

// ========== 巡检条件 ==========

export const getTeacherPatrolSettings = (params) => {
  return axios.get(`${base}/api/TeacherPatrolSettings/Get`, { params });
};

export const saveTeacherPatrolSettings = (data) => {
  return axios.post(`${base}/api/TeacherPatrolSettings/Save`, data);
};

// ========== 登记明细 / 汇总 ==========

export const getTeacherPatrolRecordPage = (params) => {
  return axios.get(`${base}/api/TeacherPatrolRecord/GetPage`, { params });
};

export const exportTeacherPatrolRecord = (params) => {
  return axios.get(`${base}/api/TeacherPatrolRecord/Export`, {
    params,
    responseType: "blob",
  });
};

export const getTeacherPatrolSummary = (params) => {
  return axios.get(`${base}/api/TeacherPatrolRecord/GetSummary`, { params });
};

export const exportTeacherPatrolSummary = (params) => {
  return axios.get(`${base}/api/TeacherPatrolRecord/ExportSummary`, {
    params,
    responseType: "blob",
  });
};

/** 时间段下拉展示：名称（HH:mm ~ HH:mm） */
export function formatTeacherPatrolSlotTime(val) {
  if (val == null || val === "") return "";
  const str = String(val).replace("T", " ");
  const timePart = str.indexOf(" ") >= 0 ? str.split(" ")[1] : str;
  return timePart.substring(0, 5);
}

export function formatTeacherPatrolSlotLabel(slot) {
  if (!slot) return "";
  const name = slot.SlotName || slot.slotName || "";
  const start = formatTeacherPatrolSlotTime(slot.StartTime != null ? slot.StartTime : slot.startTime);
  const end = formatTeacherPatrolSlotTime(slot.EndTime != null ? slot.EndTime : slot.endTime);
  if (start && end) {
    return name + "（" + start + " ~ " + end + "）";
  }
  return name;
}

/** 同步 Toolbar 校区下拉选项（须 $set，否则切换学校后 UI 不刷新） */
export function syncTeacherPatrolCampusSearchList(vm, campusList) {
  vm.campusOptions = campusList || [];
  if (!vm.searchList || !vm.searchList.length) return;
  const campusIndex = vm.searchList.findIndex(s => s.key === "campusId");
  if (campusIndex < 0) return;
  vm.$set(vm.searchList, campusIndex, {
    ...vm.searchList[campusIndex],
    options: (campusList || []).map(c => ({
      label: c.Name || c.name,
      value: c.Id != null ? c.Id : c.id
    }))
  });
}

/** 按学校加载校区并刷新 Toolbar 下拉 */
export async function loadTeacherPatrolCampusOptions(vm, departmentId) {
  if (!departmentId) {
    syncTeacherPatrolCampusSearchList(vm, []);
    return [];
  }
  const res = await getCampusList({
    page: 1,
    intPageSize: 999,
    departmentId: departmentId
  });
  const list = res.data && res.data.success ? (res.data.response.data || []) : [];
  syncTeacherPatrolCampusSearchList(vm, list);
  return list;
}

/** 清空列表表格（切换学校 / 查询失败时） */
export function clearTeacherPatrolListTable(vm) {
  if (Object.prototype.hasOwnProperty.call(vm, "users")) {
    vm.users = [];
  }
  if (Object.prototype.hasOwnProperty.call(vm, "rows")) {
    vm.rows = [];
  }
  if (Object.prototype.hasOwnProperty.call(vm, "total")) {
    vm.total = 0;
  }
  if (Object.prototype.hasOwnProperty.call(vm, "page")) {
    vm.page = 1;
  }
}

/** 清空筛选项下拉（切换学校时避免短暂显示上一所学校数据） */
export function clearTeacherPatrolFilterOptions(vm) {
  if (Object.prototype.hasOwnProperty.call(vm, "groupOptions")) {
    vm.groupOptions = [];
  }
  if (Object.prototype.hasOwnProperty.call(vm, "slotOptions")) {
    vm.slotOptions = [];
  }
  if (Object.prototype.hasOwnProperty.call(vm, "terminalOptions")) {
    vm.terminalOptions = [];
  }
}

/** 从部门树节点解析学校 Id（与后端 ResolveSchoolAndCampus 一致，取 school 节点）。最后修改：2026-10-18 */
export function resolveTeacherPatrolSchoolIdFromTreeNode(node, fallbackId) {
  const isSchoolType = (type) => {
    const t = String(type || "").toLowerCase();
    return t === "school" || t === "affiliateschool";
  };
  if (node && node.data) {
    const selfType = node.data.DeptOrgType != null ? node.data.DeptOrgType : node.data.deptOrgType;
    if (isSchoolType(selfType)) {
      return treeNodeDeptId(node.data);
    }
  }
  let n = node && node.parent;
  while (n && n.data) {
    const t = n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType;
    if (isSchoolType(t)) {
      return treeNodeDeptId(n.data);
    }
    n = n.parent;
  }
  return normalizeDeptId(fallbackId);
}

/** 当前页应使用的学校 Id（优先树节点解析结果）。最后修改：2026-10-18 */
export function getTeacherPatrolCurrentSchoolId(vm) {
  return normalizeDeptId(vm.schoolId) || normalizeDeptId(vm.DepartmentId);
}

/** 左侧切换学校：重置 Toolbar 内部筛选，避免仍显示上一所学校校区。最后修改：2026-10-18 */
export function onTeacherPatrolSchoolChange(vm, departmentId) {
  const id = normalizeDeptId(departmentId);
  vm.DepartmentId = id || '';
  vm.toolbarKey = id || '';
  if (Object.prototype.hasOwnProperty.call(vm, "schoolId")) {
    vm.schoolId = 0;
  }
  clearTeacherPatrolListTable(vm);
  clearTeacherPatrolFilterOptions(vm);
  if (!vm.filters) return;
  if (Object.prototype.hasOwnProperty.call(vm.filters, "campusId")) {
    vm.filters.campusId = null;
  }
  if (Object.prototype.hasOwnProperty.call(vm.filters, "groupId")) {
    vm.filters.groupId = null;
  }
  if (Object.prototype.hasOwnProperty.call(vm.filters, "terminalDbId")) {
    vm.filters.terminalDbId = null;
  }
  if (Object.prototype.hasOwnProperty.call(vm.filters, "timeSlotId")) {
    vm.filters.timeSlotId = null;
  }
  if (Object.prototype.hasOwnProperty.call(vm.filters, "roundNumber")) {
    vm.filters.roundNumber = null;
  }
}
